import Vue from 'vue'
import { CultureService } from '@/common/api'
import deepFreeze from '@/common/utils/deepFreeze'
import { now } from '@/common/filters'

import { cloneDeep, omit, merge } from 'lodash'

import {
  LOAD_CULTURE,
  SAVE_CULTURE
} from './actions.type'

import {
  SET_CULTURE_DIRTY,
  SET_CULTURE,
  RESET_STATE
} from './mutations.type'

export const defaultMeta = deepFreeze({
  dirty: false,
  created_at: null,
  updated_at: null,
  deleted_at: null,
  modificator: null,
  creator: null
})

const initialState = deepFreeze({
  id: null,
  name: '',
  hybrid: false,
  season: 'none',
  _meta: cloneDeep(defaultMeta)
})

export const state = cloneDeep(initialState)

export const actions = {
  async [LOAD_CULTURE] ({ commit }, id) {
    Vue.$log.debug('LOAD_CULTURE', id)
    const { data } = await CultureService.get(id)
    const culture = {
      ...cloneDeep(initialState),
      ...data,
      _meta: merge(cloneDeep(initialState._meta), data._meta, { loaded_at: now() })
    }

    commit(SET_CULTURE, culture)

    return culture
  },
  async [SAVE_CULTURE] ({ commit }, payload) {
    Vue.$log.debug('SAVE_CULTURE', payload.id)
    const { data } = await CultureService[payload.id ? 'post' : 'put'](omit(payload, ['_meta']))
    const culture = {
      ...cloneDeep(initialState),
      ...data,
      _meta: merge(cloneDeep(initialState._meta), data._meta, { loaded_at: now() })
    }

    commit(SET_CULTURE, culture)
    return culture
  }
}

export const mutations = {
  [SET_CULTURE_DIRTY] (state) {
    state._meta.dirty = true
  },
  [SET_CULTURE] (state, culture) {
    Vue.$log.debug('SET_CULTURE', culture)
    for (const f in state) {
      Vue.set(state, f, culture[f])
    }
  },
  [RESET_STATE] () {
    Vue.$log.debug('RESET_STATE')
    for (const f in state) {
      Vue.set(state, f, cloneDeep(initialState[f]))
    }
  }
}

const getters = {
  id (state) {
    return state.id || null
  },
  pageTitle (state, { name }) {
    return name
  },
  culture (state) {
    return state
  },
  name (state) {
    return String(state.name).trim()
  },
  exists (state) {
    return Boolean(state.id)
  },
  isDirty (state, { isPristine }) {
    return !isPristine
  },
  isPristine (state, { exists }) {
    return !exists || !state._meta.dirty
  },
  isInValid (state) {
    return !state.name || !state.season
  },
  isValid (state, { isInValid }) {
    return !isInValid
  },
  metaData (state) {
    return state._meta
  }
}

const namespaced = true

export default {
  namespaced,
  state,
  actions,
  mutations,
  getters
}
